import React from "react";
import "../../styles/about.css";
import { Helmet } from "react-helmet-async";

export default function AboutPage() {
  return (
    <>
    <Helmet>
  <title>About PracVerse – Practical Drone Education Company</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Learn about PracVerse – our mission, vision and work in making drone education, AI, and STEM learning practical and accessible for students."
  />
  <link rel="canonical" href="https://www.pracverse.com/about" />

  <meta property="og:title" content="About PracVerse – Practical Drone Education" />
  <meta
    property="og:description"
    content="Discover how PracVerse bridges real-world technology and education through drones, AI, and hands-on learning."
  />
  <meta property="og:url" content="https://www.pracverse.com/about" />
  <meta property="og:image" content="https://www.pracverse.com/images/og-about.jpg" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About PracVerse",
      "url": "https://www.pracverse.com/about",
      "mainEntity": {
        "@type": "Organization",
        "name": "PracVerse",
        "url": "https://www.pracverse.com"
      }
    })}
  </script>
</Helmet>


    <div className="about-page">

      {/* ABOUT HERO SECTION */}
<section className="about-hero-section">
  <div className="container about-hero-grid">

    {/* LEFT SIDE */}
    <div className="about-hero-left">
      <h1 className="about-hero-title">Pioneering the Future of Drone Education</h1>

      <p className="about-hero-sub">
        We're on a mission to democratize access to cutting-edge drone technology
        education, empowering students and educators worldwide with the skills
        needed for tomorrow's careers.
      </p>

      <div className="about-hero-actions">
        <a href="/contact" className="btn primary large">Join Our Mission</a>
        <a href="/partnerships" className="btn outline large">Partner With Us</a>
      </div>
    </div>

    {/* RIGHT SIDE */}
    <div className="about-hero-right">
      <div className="about-hero-media">
        <img
          src="/images/about.png"
          alt="Students working with drone"
        />
      </div>
    </div>

  </div>
</section>




{/* MISSION & VISION CARDS */}
<section className="mission-vision-section">
  <div className="container mv-grid">
    {/* Mission Card */}
    <article className="mv-card">
      <div className="mv-card-top">
        <div className="mv-icon" aria-hidden="true">
          {/* target icon */}
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="#6B62A7" strokeWidth="1.2" opacity="0.12"/>
            <circle cx="12" cy="12" r="5" stroke="#6B62A7" strokeWidth="1.5"/>
            <circle cx="12" cy="12" r="2" fill="#6B62A7"/>
          </svg>
        </div>
        <h3 className="mv-title">Our Mission</h3>
      </div>

      <div className="mv-body">
        <p className="mv-desc">
          To revolutionize STEM education by providing comprehensive, accessible, and innovative drone technology
          programs that prepare students for the rapidly evolving technological landscape. We believe every student
          deserves the opportunity to explore, create, and excel in emerging technology fields.
        </p>

        <ul className="mv-checks">
          <li><span className="check-mark">✓</span> Democratize access to advanced technology education</li>
          <li><span className="check-mark">✓</span> Bridge the gap between theory and practical application</li>
          <li><span className="check-mark">✓</span> Empower educators with cutting-edge teaching tools</li>
        </ul>
      </div>
    </article>

    {/* Vision Card */}
    <article className="mv-card">
      <div className="mv-card-top">
        <div className="mv-icon mv-icon-vision" aria-hidden="true">
          {/* eye icon */}
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#6B62A7" strokeWidth="1.2" opacity="0.12"/>
            <circle cx="12" cy="12" r="3.2" stroke="#6B62A7" strokeWidth="1.6"/>
          </svg>
        </div>
        <h3 className="mv-title">Our Vision</h3>
      </div>

      <div className="mv-body">
        <p className="mv-desc">
          To be the global leader in drone education, creating a world where every student has the opportunity to
          develop critical thinking, problem-solving, and technical skills through hands-on experience with
          cutting-edge technology.
        </p>

        <ul className="mv-checks">
          <li><span className="check-mark">✓</span> Global network of drone education centers</li>
          <li><span className="check-mark">✓</span> Industry-standard certification programs</li>
          <li><span className="check-mark">✓</span> Sustainable educational technology ecosystem</li>
        </ul>
      </div>
    </article>
  </div>
</section>





{/* CORE VALUES */}
<section id="core-values" className="core-values-section">
  <div className="container">
    <header className="core-values-header" style={{ textAlign: "center", marginBottom: 28 }}>
      <h2>Our Core Values</h2>
      <p className="core-values-sub">
        These fundamental principles guide every decision we make and every program we develop,
        ensuring we stay true to our mission of transforming education.
      </p>
    </header>

    <div className="core-values-grid">
      <article className="value-card">
        <div className="value-icon" aria-hidden="true">
          {/* lightbulb */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18h6M10 22h4" stroke="#1F2340" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.5 14a4.5 4.5 0 1 1 5 0c0 1.8-1 2.8-1.5 3.2H11c-.5-.4-1.5-1.4-1.5-3.2z" stroke="#1F2340" strokeWidth="1.2" fill="none"/>
          </svg>
        </div>
        <h3 className="value-title">Innovation</h3>
        <p className="value-desc">We continuously evolve our programs to incorporate the latest advancements in drone technology and educational methodologies.</p>
      </article>

      <article className="value-card">
        <div className="value-icon" aria-hidden="true">
          {/* users */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2" stroke="#1F2340" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="8" r="3" stroke="#1F2340" strokeWidth="1.4"/>
          </svg>
        </div>
        <h3 className="value-title">Accessibility</h3>
        <p className="value-desc">Making cutting-edge drone education accessible to students from all backgrounds through partnerships and funding initiatives.</p>
      </article>

      <article className="value-card">
        <div className="value-icon" aria-hidden="true">
          {/* ribbon */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2l3 6 6 .9-4.5 4 1 6L12 16l-5.5 2.9 1-6L3 8.9 9 8 12 2z" stroke="#1F2340" strokeWidth="1.2" fill="none"/>
          </svg>
        </div>
        <h3 className="value-title">Excellence</h3>
        <p className="value-desc">Maintaining the highest standards in curriculum design, instruction quality, and student outcomes across all our programs.</p>
      </article>

      <article className="value-card">
        <div className="value-icon" aria-hidden="true">
          {/* globe */}
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="#1F2340" strokeWidth="1.2"/>
            <path d="M2 12h20M12 2c2 3 2 8 2 10s0 7-2 10" stroke="#1F2340" strokeWidth="1.0" strokeLinecap="round"/>
          </svg>
        </div>
        <h3 className="value-title">Impact</h3>
        <p className="value-desc">Creating meaningful change in STEM education by preparing students for careers in emerging technology fields.</p>
      </article>
    </div>
  </div>
</section>




{/* IMPACT IN NUMBERS */}
<section id="impact-numbers" className="impact-numbers-section">
  <div className="container">
    <header className="impact-header" style={{ textAlign: "center", marginBottom: 24 }}>
      <h2>Our Impact in Numbers</h2>
      <p className="impact-sub">
        Since our founding, we've been committed to measuring and maximizing our impact on students, educators,
        and communities worldwide.
      </p>
    </header>

    <div className="impact-grid">
      <div className="impact-item">
        <div className="impact-number">10,000+</div>
        <div className="impact-label">Students Educated</div>
      </div>

      <div className="impact-item">
        <div className="impact-number">45+</div>
        <div className="impact-label">Partner Institutions</div>
      </div>

      <div className="impact-item">
        <div className="impact-number">10+</div>
        <div className="impact-label">Cities Reached</div>
      </div>

      <div className="impact-item">
        <div className="impact-number">100%</div>
        <div className="impact-label">Student Satisfaction</div>
      </div>
    </div>
  </div>
</section>




{/* LEADERSHIP TEAM */}
<section className="leadership-section">
  <div className="container">
    <header className="leadership-header">
      <h2>Meet Our Leadership Team</h2>
      <p className="leadership-sub">
        “Driving India’s shift toward hands-on, real-world education by bringing global expertise to transform STEM learning for the next generation.”

      </p>
    </header>

    <div className="leadership-grid">

     

      {/* CARD 1 */}
      <article className="leader-card">
        <div className="leader-image">
          <img src="/images/Yash.jpg" alt="Yash Wardhan" />
        </div>
        <h3 className="leader-name">Yash Wardhan</h3>
        <p className="leader-role">Co-Founder & CEO</p>
        <p className="leader-desc">
          {/* An IIM Kozhikode postgraduate and certified drone pilot with 2+ years of strategic product management experience, leading innovation and execution. */}
          Yash Wardhan, Co-Founder & CEO of PracVerse, brings together product management expertise, drone technology experience, and strong academics. An IIM Kozhikode MBA, licensed drone pilot, and trained in International Finance at King’s College London, he blends technical and global perspectives in his leadership. <br/>

He has worked with schools across major cities, delivering STEM and drone education programs that make learning practical and future-ready. Yash continues to inspire students to explore drones, robotics, AI, and automation through hands-on, application-driven learning.
        </p>
      </article>

       {/* CARD 2 */}
      <article className="leader-card">
        <div className="leader-image">
          <img src="/images/Harshika.jpeg" alt="Harshika Dewangan" />
        </div>
        <h3 className="leader-name">Harshika Dewangan</h3>
        <p className="leader-role">Co-Founder & MD</p>
        <p className="leader-desc">
          {/* A certified drone pilot and Delhi University alumnus, bringing 2+ years of dynamic sales and marketing expertise to drive growth and impact. */}
          Harshika Dewangan, Co-Founder & Managing Director of PracVerse, is a licensed drone pilot who leads the development and delivery of hands-on STEM and drone learning programs across schools and colleges in India. A Delhi University graduate, she believes education becomes meaningful when it is practical, experiential, and rooted in real-world technology.<br/>

{/* Through PracVerse’s Life With Drone program, she has conducted workshops on drone flying, safety, coding logic, gesture and voice control, and real industrial applications. She also works with colleges, universities, and government bodies to build awareness about emerging technologies and future career paths. */}

Through PracVerse’s Life With Drone program, she conducts workshops on drone flying, safety, coding logic, and real industrial applications, while collaborating with colleges and institutions to promote emerging technologies — driven by her mission to inspire curiosity and build practical, future-ready skills.
        </p>
      </article>

    </div>
  </div>
</section>




{/* OUR STORY */}
<section id="our-story" className="our-story-section">
  <div className="container our-story-grid">
    <div className="story-left">
      <h2 className="story-title">Our Story</h2>

      <div className="story-body">
        <p>
          PracVerse began with a simple but powerful belief: students deserve learning that feels alive.
Not memorised. Not abstract. But something they can touch, build, fly, and truly understand.
        </p>

        <p>
         Founded by IIT & IIM alumni, PracVerse was created to bridge the widening gap between what students learn in classrooms and the skills the world now demands. Drone technology became our medium not only for its excitement but for how seamlessly it brings together STEM, coding, AI concepts, and hands-on creativity, giving learners the chance to think, build, fly, and innovate.
        </p>

        <p>
          What began in a few classrooms has now expanded across multiple cities, empowering students to understand not just what to study, but why it matters. Through real, practical drone experiences, we’ve seen learners discover confidence, curiosity, and a sense of possibility they never knew they had.
        </p>

        <p>
          Our mission is simple: Help every learner build skills that matter today, and careers that will matter tomorrow.

        </p>
      </div>
    </div>

    <div className="story-right">
      <div className="story-media-frame">
        <img src="/images/Our_story.jpeg" alt="Our story image" />
      </div>
    </div>
  </div>
</section>



{/* JOIN US CTA */}
<section className="about-cta-section">
  <div className="about-cta-container">
    <h2 className="about-cta-title">Join Us in Shaping the Future</h2>

    <p className="about-cta-subtitle">
      Whether you're an educator, institution, or organization, there are many ways to get
      involved in our mission to transform STEM education through drone technology.
    </p>

    <div className="about-cta-buttons">
      <a className="about-cta-btn-primary" href="/contact">Become a Partner</a>
      <a className="about-cta-btn-secondary" href="/contact">Get in Touch</a>
    </div>
  </div>
</section>


    </div>
    </>
  );
}
